import {BehaviorSubject, Subject, combineLatest} from 'rxjs';
import {switchMap, skipUntil, filter} from 'rxjs/operators';
import {mc} from '@/core';
import {announcementApi} from '@/api/announcement';
import {accountApi} from '@/api/account';
import {activityApi} from '@/api/activity';
import {browser$} from '@/streams/browser';
import {userStatus$} from '@/streams/auth';

export const query$ = new Subject();
export const bannerList$ = new BehaviorSubject([]);
export const tasks$ = new BehaviorSubject([]);
export const hotSpots$ = new BehaviorSubject([]);
export const hotContracts$ = new BehaviorSubject([]);

combineLatest([query$, userStatus$])
  .pipe(
    skipUntil(browser$),
    filter(([, status]) => status !== 'Init'),
    switchMap(([query, status]) => loadBannerList(query, status))
  )
  .subscribe((x) => bannerList$.next(x));

async function loadBannerList(query, status) {
  const {data, error} = await (status === 'Login' ? announcementApi.contentViewLogin(query) : announcementApi.contentViewLogout(query));
  if (data) {
    return data.rows;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
  return [];
}

browser$.subscribe(async () => {
  const {data} = await activityApi.getHotSpotsAndContracts();
  hotSpots$.next(data.spot);
  hotContracts$.next(data.contract);
});

export async function loadTasksList() {
  const {data, error} = await accountApi.getTasksList();
  if (data) {
    return tasks$.next(data.rows);
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
  return [];
}
